export default "__VITE_ASSET__CfJZuW6z__"